import React, { useEffect, useRef } from "react"

import chatgpt from "../assets/img/clientlab/yapay-zeka/chatgpt.webp"
import claude from "../assets/img/clientlab/yapay-zeka/Claude.webp"
import copilot from "../assets/img/clientlab/yapay-zeka/copilot.webp"
import gemini from "../assets/img/clientlab/yapay-zeka/gemini.webp"
import llama from "../assets/img/clientlab/yapay-zeka/Llama.webp"
import runway from "../assets/img/clientlab/yapay-zeka/runway.webp"

const logos = [
  { src: chatgpt, alt: "ChatGPT" },
  { src: claude, alt: "Claude" },
  { src: copilot, alt: "Copilot" },
  { src: gemini, alt: "Gemini" },
  { src: llama, alt: "LLaMA" },
  { src: runway, alt: "Runway" },
]

const AiLogosMarquee = ({ speed = 80 }) => {
  const containerRef = useRef(null)
  const trackRef = useRef(null)
  const rafId = useRef(null)
  const position = useRef(0)
  const trackWidth = useRef(0)

  const animate = () => {
    position.current -= speed / 60 / 3
    if (Math.abs(position.current) >= trackWidth.current) {
      position.current = position.current % trackWidth.current
    }
    if (containerRef.current) {
      containerRef.current.style.transform = `translateX(${position.current}px)`
    }
    rafId.current = requestAnimationFrame(animate)
  }

  useEffect(() => {
    if (trackRef.current) {
      trackWidth.current = trackRef.current.getBoundingClientRect().width
    }
    rafId.current = requestAnimationFrame(animate)
    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current)
    }
  }, [speed])

  const logoItem = (logo, key) => (
    <div
      key={key}
      className="marquee__item"
      style={{ flexShrink: 0, width: "200px", marginRight: "3rem", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <img
        src={logo.src}
        alt={logo.alt}
        style={{ height: "70px", width: "100%", objectFit: "contain", backfaceVisibility: "hidden" }}
      />
    </div>
  )

  return (
    <div className="wrapper lab">
      <div className="marquee" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
        <div
          ref={containerRef}
          className="marquee__ctn"
          style={{ display: "inline-flex", willChange: "transform" }}
        >
          <div ref={trackRef} className="marquee__track" style={{ display: "flex", alignItems: "center" }}>
            {logos.map((logo, i) => logoItem(logo, i))}
          </div>
          <div className="marquee__track" style={{ display: "flex", alignItems: "center" }} aria-hidden="true">
            {logos.map((logo, i) => logoItem(logo, `dup-${i}`))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AiLogosMarquee
